// extracted by mini-css-extract-plugin
export default {"container":"style_container__+O4-l","img":"style_img__GzTSV","text":"style_text__KCDwZ","submitBtn":"style_submitBtn__pzOBJ"};